import React from 'react';
import { useUser } from '../contexts/UserContext';
import { Outlet } from 'react-router-dom';
//import siloBackground from '../assets/images/silo-grains-cereales.jpg';
//import siloBackground from '../assets/images/silo-grains.avif';
//import Breadcrumbs from '../routes/Breadcrumbs';

const Dashboard = () => {

  //contexte de l'utilisateur connecté
  const user = useUser();

  
  return (    
    <div className='md:px-10 py-4 md:py-8 md:min-h-screen justify-center items-center bg-gray-100'>
      {/*<h1 className='text-center text-secondary py-4 font-bold md:text-xl'>Bonjour {user.user.userData.prenom}, tu es un profil {user.user.userData.type}</h1>
      {/*<div className='py-4'>
        <Breadcrumbs />
      </div>*/}
          
      <Outlet />
    </div>
  );

  /*  
  return (    
    <div
      className="relative min-h-screen md:px-10 py-4 md:py-8 md:min-h-screen justify-center items-center bg-gray-100 bg-cover bg-center"
      style={{
        backgroundImage: `url(${siloBackground})`,
      }}
    >
   
      <div className="absolute inset-0 bg-gray-900 bg-opacity-50 "></div>
      
      <div className="relative">
        <Outlet />
      </div>
    </div>
  );*/
};

export default Dashboard;
